import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from '../../../services/theme/theme.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadDropDialogComponent } from '../file-upload-drop-dialog/file-upload-drop-dialog.component';
import { SiteReviewService } from 'app/services/site-review.service';
import { ResetComponent } from '../reset/reset.component';
import { IdbService } from 'app/services/idb.service';
//import { ChatterService } from 'app/chat/shared/services/chatter.service';
import { DataStoreService } from 'app/services/datastore.service';
import { BulkLoaderService } from 'app/services/bulk-loader.service';
import { ReleaseNotesService, RELEASE_NOTES_FEATURE_CODE } from 'app/services/release-notes.service';
import { openReleaseNotesDialog } from '../release-notes-dialog/release-notes-dialog';
import { FeatureFlagService } from 'app/core/feature-flags/feature-flags.service';
import { environment } from 'environments/environment';

export const isProduction = environment.production;// "https://sitereviewapi.azurewebsites.net";


@Component({
  selector: 'topbar',
  templateUrl: './topbar.template.html',
  styleUrls: ['./topbar.component.css'],
  standalone: false
})
export class TopbarComponent implements OnInit {
  @Input() sidenav;
  @Input() notificPanel;
  showChatter = false;
  chatterBoxClass = 'chatterbox-hide';

  egretThemes;
  User;

  showWarning = false;

  constructor(
    private themeService: ThemeService,
    private auth: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private idb: IdbService,
    private bulkLoader: BulkLoaderService,
    private db: SiteReviewService,
    private dataStore: DataStoreService,
    private releaseNotes: ReleaseNotesService,
    private featureFlags: FeatureFlagService

  ) { }

  get releaseNotesEnabled(): boolean {
    return this.featureFlags.isEnabled(RELEASE_NOTES_FEATURE_CODE);
  }

  /**
   * "What's New" — re-opens the latest published release notes on demand,
   * read-only (no dismiss checkbox, no server write).
   */
  showReleaseNotes() {
    this.releaseNotes.getLatest().subscribe({
      next: (note) => {
        if (!note) return;
        openReleaseNotesDialog(this.dialog, { note, allowDismiss: false });
      },
      error: (err) => console.error('Error loading release notes:', err),
    });
  }

  async ngOnInit() {
    this.showWarning = isProduction ? false : true;
    this.egretThemes = this.themeService.egretThemes;
    let objUser = localStorage.getItem("User");
    this.User = JSON.parse(objUser);
    //console.log('environment.production', isProduction)
  }


  clearIndexDB() {
    //console.log('clearing local db')
    const dialogRef = this.dialog.open(ResetComponent, {
      height: '450px',
      width: '800px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log("the reset data dialog was closed")
      this.dialog.closeAll();
      //location.reload()
      this.auth.logout()
      //   this.router.navigate(['../../'], { relativeTo: this.route });
    });
  }




  toggleChatterBox() {
    if (this.chatterBoxClass == 'chatterbox-show') {
      this.chatterBoxClass = 'chatterbox-hide';
      this.showChatter = false;
    } else {
      this.chatterBoxClass = 'chatterbox-show'
      this.showChatter = true;
    }
  }


  toggleNotific() {
    this.notificPanel.toggle();
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  async logout() {
    //console.log('logging out...')
    try {
      await this.idb.clearData('jobs');
      this.auth.logout();
      //console.log('Logged Out Successfully')
    } catch (e) {
      console.warn('ERROR LOGGING OUT', e)
      this.router.navigate(['/sessions/signin'])
    }
    //
  }

  newAlert() {
    this.router.navigate(['/admin/alerts/new']);
  }

  async help() {
    var url = 'https://support.pinnaclepowerservices.com/';
    document.location.href=url;
  }

  async refreshJobList() {
    this.bulkLoader.jobListTrigger.next(new Date().getTime());
  }

  fileUploadDropZoneDlg() {
    const dialogRef = this.dialog.open(FileUploadDropDialogComponent, { width: '90%', height: '90%', panelClass: 'my-dialog' });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else {

      }
    });
  }
}
